import clsx from 'clsx';
import { FC } from 'react';

import styles from './styles.module.css';

interface Props {
  className?: string;
  width?: number;
}

const Divider: FC<Props> = ({ className, width }) => {
  return <div className={clsx(styles.divider, className)} style={{ width }} />;
};

export default Divider;
